interface IProps {
  title: string;
  subTitle?: string;
}

export const TabHeaderSmall = ({ title, subTitle }: IProps) => {
  return (
    <>
      <h3 className="u-mT-0 u-mB-0">{title}</h3>
      {subTitle && <p>{subTitle}</p>}{' '}
    </>
  );
};
